import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class InvesmentAmountIsBelowMinium extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('The required investment is below the minimum', ...args);
    }
}
export default InvesmentAmountIsBelowMinium;
